import script from "./ProfileSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSection.vue?vue&type=style&index=0&id=739e1a56&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739e1a56"]])

export default __exports__